import Result from './3rdPartAuth.vue';

export default Result;
